










































import { IFormFieldOptionData, IFormSectionFieldData } from '@/models';
import { ErrorManager } from '@/models/error';
import { IFetchFormFieldOptionTodosParams } from '@/services';
import Vue, { PropType } from 'vue';
import { mapActions } from 'vuex';

import FormBuilderOptionTabWindow from '../FormBuilderOptionTabWindow.vue';
import FormBuilderTodoTabDrawer from '../FormBuilderTodoDrawer.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import { PropertyTabs } from '../FormBuilderPropertiesDrawer.vue';

export default Vue.extend({
  name: 'FormBuilderOptionTab',

  components: {
    FormBuilderOptionTabWindow,
    FormBuilderTodoTabDrawer,
    ErrorAlert
  },

  props: {
    sectionField: Object as PropType<IFormSectionFieldData>,
    templateId: Number
  },

  data() {
    return {
      PropertyTabs,
      selectedOption: null as null | IFormFieldOptionData,

      loading: false,
      errorMessage: '',
      detailErrorMessage: '',

      drawer: false
    };
  },

  mounted() {
    this.loadFieldOptionsTodos();
  },

  methods: {
    ...mapActions({
      fetchFormFieldOptionTodos: 'formTemplate/fetchFormFieldOptionTodos'
    }),

    loadFieldOptionsTodos() {
      const params = {
        templateId: this.templateId,
        sectionFieldId: this.sectionField.id
      } as IFetchFormFieldOptionTodosParams;

      this.loading = true;

      this.fetchFormFieldOptionTodos({ params })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    },

    openTodoDrawer(option: IFormFieldOptionData) {
      this.selectedOption = option;
      this.drawer = true;
    },

    clearAllErrors() {
      this.detailErrorMessage = '';
      this.errorMessage = '';
    },

    save() {
      this.$emit('save');
    },

    goToTabWindow(tab: PropertyTabs) {
      this.$emit('goToTabWindow', tab);
    }
  }
});
